// Editor.js list items are plain strings in the legacy format and
// { content, meta, items } objects (possibly nested) in the newer one.
export const getListItemHtml = (item: any): string => {
  if (item === null || item === undefined) return "";
  if (typeof item === "string") return item;
  if (typeof item === "number") return String(item);

  const content = item.content ?? item.text ?? "";
  const nested = Array.isArray(item.items) && item.items.length
    ? listToHtml({ style: item.meta?.style, items: item.items })
    : "";
  return `${content}${nested}`;
};

export const listToHtml = (data: any): string => {
  const tag = data?.style === "ordered" ? "ol" : "ul";
  const items = (data?.items || [])
    .map((item: any) => `<li>${getListItemHtml(item)}</li>`)
    .join("");
  return `<${tag}>${items}</${tag}>`;
};
